import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  // The Unsubscribe screen keeps the whole rejection, not the server body: its status decides between
  // logging out (404) and the error page (422). See src/utils/rejectedResponse.js.
  ...requestCases('PROFILE_UNSUBCRIBE', { success: dataAs('profile_unsubscribe'), error: payload => payload }),
});
